import { lightTheme, vDriveDeliveryStatus } from '@vgrubs/components';
import { CarIcon } from '../../assets';
import { RenderStatus } from 'components/src/adminPages/Deliveries/DeliveriesStyled';
import styled from 'styled-components';

export const DeliveryProgressBar = ({
  status,
}: {
  status: vDriveDeliveryStatus;
}) => (
  <Container>
    <CarIconContainer left={RenderStatus(status)?.progress ?? 0}>
      <CarIcon color={RenderStatus(status)?.color ?? lightTheme.gray} />
    </CarIconContainer>
    <ProgressBarFill
      color={RenderStatus(status)?.color ?? lightTheme.gray}
      progress={RenderStatus(status)?.progress ?? 0}
    />
  </Container>
);

const Container = styled.div`
  width: 100%;
  height: 14px;
  background-color: ${({ theme }) => theme.gray};
  border-radius: 14px;
  position: relative;
  border: 0.5px solid ${({ theme }) => theme.lightGray};
  /* Not margin-block: Chrome < 87 (old Android WebViews) drops it. */
  margin: 20px 0;
`;

const ProgressBarFill = styled.div<{ color: string; progress: number }>`
  height: 100%;
  background-color: ${({ color }) => color};
  border-radius: 14px;
  width: ${({ progress }) => `${progress}%`};
`;

const CarIconContainer = styled.div<{ left: number }>`
  position: absolute;
  left: ${({ left }) => `${left}%`};
  top: 50%;
  transform: ${({ left }) =>
    left > 10 ? 'translate(-90%, -50%)' : 'translate(-5px, -50%)'};
  width: 40px;
  height: 40px;
`;
